import React from "react";
import TagButtonZ from "../atoms/TagButtonZ";
import SvgIcn from "../../data/IconCompo";

const TagGroup = ({
  tags,
  selectedTag,
  onChange,
  name,
  selectedMode,
  favsNumber,
  itemsNumber,
  allCatalogCount,
}) => {
  const handleTagClick = (tagValue) => {
    if (onChange) {
      if (tagValue === "ALL") {
        // Clear the tag filter when ALL is clicked
        onChange({ name: name, value: "" });
      } else if (selectedTag === tagValue) {
        // If clicking the already selected tag, deselect it
        onChange({ name: name, value: "" });
      } else {
        // Select the new tag
        onChange({ name: name, value: tagValue });
      }
    }
  };

  // Function to determine if a tag should be shown as selected
  const isTagSelected = (tag) => {
    if (tag === "ALL") {
      // ALL is selected when no other tag is selected
      return !selectedTag || selectedTag === "";
    }
    return selectedTag === tag;
  };
  const getLabel = (tag) => {
    if (tag == "Favs") {
      return (
        <div className="taglabel">
          <SvgIcn name="fav" />

          <p>
            {tag} {favsNumber}
          </p>
        </div>
      );
    } else if (tag == "ALL") {
      const allCount =
        allCatalogCount !== undefined && allCatalogCount !== null
          ? allCatalogCount
          : itemsNumber;
      return (
        <div className="taglabel">
          <SvgIcn name="dots_on" />
          <p>
            {tag} {allCount}
          </p>
        </div>
      );
    } else {
      return (
        <>
          <p>{tag}</p>
        </>
      );
    }
  };
  return (
    <div className={`tags-box`}>
      {tags.map((tag) => (
        <TagButtonZ
          key={tag}
          label={getLabel(tag)}
          className={
            isTagSelected(tag)
              ? `selected ${selectedMode && `${selectedMode}-bg`} ${
                  selectedMode && `${selectedMode}-hover`
                }`
              : `${selectedMode && `${selectedMode}-hover`}`
          }
          onClick={() => handleTagClick(tag)}
        />
      ))}
    </div>
  );
};

export default TagGroup;
